/* Product policy summaries use the current Shopify policy body; no product inputs are changed. */
(function () {
  'use strict';
  function policyPath(value) {
    try { return new URL(value, window.location.href).pathname.replace(/\/$/, ''); }
    catch (_) { return ''; }
  }
  function setup() {
    document.querySelectorAll('[data-lp5000-product]').forEach(function (root) {
      if (root.dataset.lpPoliciesReady) return;
      var dialogs = Array.from(root.querySelectorAll('[data-lp-policy-dialog]'));
      if (!dialogs.length) return;
      root.dataset.lpPoliciesReady = 'true';
      dialogs.forEach(function (dialog) {
        var source = dialog.querySelector('[data-lp-policy-source]');
        var content = dialog.querySelector('[data-lp-policy-content]');
        var copy = source.content.cloneNode(true);
        var marker = Array.from(copy.querySelectorAll('p')).find(function (p) {
          return /^(SHIPPING|RETURNS) AT A GLANCE$/i.test(p.textContent.trim());
        });
        // Prefer the policy's own summary card. Fall back to the full policy if it has none.
        if (marker && marker.parentElement) {
          var summary = marker.parentElement.cloneNode(true);
          var label = Array.from(summary.querySelectorAll('p')).find(function (p) {
            return /^(SHIPPING|RETURNS) AT A GLANCE$/i.test(p.textContent.trim());
          });
          if (label) label.remove();
          content.appendChild(summary);
        } else content.appendChild(copy);
        content.querySelectorAll('[style]').forEach(function (el) { el.removeAttribute('style'); });
        dialog.querySelector('[data-lp-policy-close]').addEventListener('click', function () { dialog.close(); });
        dialog.addEventListener('close', function () {
          if (!document.querySelector('[data-lp-policy-dialog][open]')) document.documentElement.classList.remove('lp-policy-is-open');
          if (dialog.lpReturnFocus && dialog.lpReturnFocus.isConnected) dialog.lpReturnFocus.focus({ preventScroll: true });
        });
        dialog.addEventListener('click', function (event) {
          if (event.target !== dialog) return;
          var rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
      root.querySelectorAll('a[href]').forEach(function (link) {
        if (link.closest('[data-lp-policy-dialog]')) return;
        var dialog = dialogs.find(function (item) { return policyPath(item.dataset.policyUrl) === policyPath(link.href); });
        if (dialog && typeof dialog.showModal === 'function') {
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', dialog.id);
        }
      });
      root.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var link = event.target.closest('a[href]');
        if (!link || link.closest('[data-lp-policy-dialog]')) return;
        var dialog = dialogs.find(function (item) { return policyPath(item.dataset.policyUrl) === policyPath(link.href); });
        // Native dialog provides focus containment and Escape. Older browsers keep the regular link.
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        dialog.lpReturnFocus = link;
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('lp-policy-is-open');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', function () {
    if (!document.querySelector('[data-lp-policy-dialog][open]')) document.documentElement.classList.remove('lp-policy-is-open');
  });
}());
